import { render } from "./SubmitExpenseType.vue?vue&type=template&id=4a26dc0c"
import script from "./SubmitExpenseType.vue?vue&type=script&lang=js"
export * from "./SubmitExpenseType.vue?vue&type=script&lang=js"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__